import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { usePostHogTracking } from '../hooks/usePostHogTracking';
import { useAuth } from '../context/AuthContext';

export const ApplyPage: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { trackEvent } = usePostHogTracking();

  useEffect(() => {
    // Extract jobId from URL query params (e.g., /apply?jobId=linkedin-swe-123)
    const jobId = searchParams.get('jobId');

    console.log('[ApplyPage] Apply page visited', {
      jobId: jobId || 'none',
      isAuthenticated: !!user
    });

    // Track that user visited /apply page with jobId
    trackEvent('job_board_apply', {
      page: '/apply',
      source: 'external_job_board',
      jobId: jobId || 'unknown',
      has_job_id: !!jobId
    });

    // If already authenticated, redirect to dashboard
    if (user) {
      console.log('[ApplyPage] User already authenticated, redirecting to dashboard');
      navigate('/dashboard');
      return;
    }

    // If not authenticated, store jobId and redirect to signup
    console.log('[ApplyPage] User not authenticated, redirecting to signup', { jobId });

    // Store jobId in sessionStorage if present
    if (jobId) {
      sessionStorage.setItem('pendingJobId', jobId);
      console.log('[ApplyPage] Job ID stored in sessionStorage:', jobId);
    }

    // Redirect to signup page
    navigate('/signup');
  }, [user, navigate, trackEvent, searchParams]);

  // Show loading state while redirecting
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-sky-50">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-16 w-16 border-b-4 border-blue-600 mb-6"></div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Redirecting to Sign Up...</h2>
        <p className="text-gray-600">Please wait while we redirect you to create your account.</p>
      </div>
    </div>
  );
};

